import { render, staticRenderFns } from "./features-summary-card.vue?vue&type=template&id=6791d5e8&scoped=true&"
import script from "./features-summary-card.vue?vue&type=script&lang=js&"
export * from "./features-summary-card.vue?vue&type=script&lang=js&"
import style0 from "./features-summary-card.vue?vue&type=style&index=0&id=6791d5e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6791d5e8",
  null
  
)

export default component.exports